import InsuredToSave from '@/modules/common/common/models/MID/InsuredToSave'

export class PetsInsuredCivilLiabilityToSave extends InsuredToSave {
  isPolicyHolder: boolean
  constructor(data: any = {}) {
    super(data)

    this.isPolicyHolder = data.isPolicyHolder
  }
}
